
export class App_User {

  
    ID: number;
    Sifre: string;
    Name: string;
    Type:number;
    OffMode:number;
    

 

}









// WEBPACK FOOTER //
// ./src/models/App_User.ts